import React from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import PhoneInput from '../Inputs/PhoneInput'
import ContinueEnabled from '../Buttons/ContinueEnabled'
import ContinueDisabled from '../Buttons/ContinueDisabled'
import PrivacyTerms from '../PrivacyTerms/PrivacyTerms'
function PhoneComponents({ phone, setPhone, onContinue, disabled }) {
  return (
    <Row>
      <Col md={12} xs={12}>
        <Image src={`${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`} className='login-logo' alt="logo" title="Dastaan" />
      </Col>
      <Col md={12} xs={12} className='login-continue-wrapper'>
        <span className='login-continue-txt white-text'>Login to Continue</span>
      </Col>
      <Col md={12} xs={12} >
        <PhoneInput phone={phone} setPhone={setPhone} />
      </Col>
      <Col md={12} xs={12}>
        {phone !== undefined && phone.length === 10 ? <ContinueEnabled onContinue={onContinue} disabled={disabled} label="Get OTP" /> : <ContinueDisabled label="Get OTP" />}
      </Col>
      <Col md={12} xs={12} className="mt-3">
        <PrivacyTerms />
      </Col>
    </Row>
  )
}
export default PhoneComponents